import React from 'react';

function MessageInput({ message, setMessage }) {
  return (
    <div style={{ marginTop: '1rem' }}>
      <h3>Enter a Personal Message</h3>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Roses are red, Violets are blue..."
        maxLength={300}
        rows={4}
        style={{
          width: '100%',
          maxWidth: '500px',
          padding: '0.5rem',
          fontSize: '1rem',
          borderRadius: '4px',
          border: '1px solid #ccc',
          resize: 'vertical',
        }}
      />
      <div style={{ fontSize: '0.8rem', marginTop: '0.3rem', color: '#666' }}>
        {message.length} / 300 characters
      </div>
    </div>
  );
}

export default MessageInput;

